const linkBoxData = require(`../brands/${process.env.BRAND}/public/data/linksBox.json`);
export { linkBoxData as linksBox };
